import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DeleteEnvironmentDialogData {
  environmentName: string;
}

@Component({
  standalone: false,
  selector: 'app-delete-environment-dialog',
  template: `
    <div class="app-dialog-shell">
      <div mat-dialog-title class="app-dialog-shell__header">
        <div class="app-dialog-shell__title-group">
          <div class="app-dialog-shell__title-icon">
            <mat-icon>delete_forever</mat-icon>
          </div>
          <div class="app-dialog-shell__title-copy">
            <h2 class="app-dialog-shell__title">Delete Environment</h2>
            <p class="app-dialog-shell__subtitle">This permanently removes the selected environment and its runtime state.</p>
          </div>
        </div>
        <button mat-icon-button type="button" class="app-dialog-shell__close" (click)="onCancel()" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div mat-dialog-content class="app-dialog-shell__body">
        <p>Are you sure you want to permanently delete this environment?</p>
        <div class="app-dialog-code-block"><code>{{ data.environmentName }}</code></div>
        <div class="app-dialog-warning">
          <mat-icon>warning_amber</mat-icon>
          <span>This action cannot be undone.</span>
        </div>
      </div>

      <div mat-dialog-actions class="app-dialog-shell__actions">
        <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="warn" type="button" (click)="onConfirm()">
          <mat-icon>delete_forever</mat-icon>
          Delete Environment
        </button>
      </div>
    </div>
  `,
  styles: [``]
})
export class DeleteEnvironmentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteEnvironmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteEnvironmentDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
